import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, money, dt } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import { Page, Field, btnGold, btnGhost, STATUS_FR } from "../../components/store/ui";

export default function Account() {
  const { user, setUser, logout, t } = useApp();
  const [tab, setTab] = useState("orders");
  const [orders, setOrders] = useState([]);
  const [returns, setReturns] = useState([]);
  const [prof, setProf] = useState({ name: user.name, phone: user.phone || "", default_market: user.default_market || "" });
  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => {});
    api.get("/returns").then((r) => setReturns(r.data)).catch(() => {});
  }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/auth/me", prof); setUser(data); toast.success("Profil enregistré"); } catch (er) { toast.error(errMsg(er)); }
  };
  const tabs = [["orders", t("orders")], ["returns", t("returns_tab")], ["profile", t("profile")]];
  return (
    <Page kicker={user.email} title={`Bonjour, ${user.name}`}>
      <div className="flex gap-6 border-b border-white/5 mb-10">
        {tabs.map(([k, l]) => <button key={k} data-testid={`account-tab-${k}`} onClick={() => setTab(k)} className={`pb-3 text-sm ${tab === k ? "border-b-2 border-[#C9A96E] text-white" : "text-muted-foreground"}`}>{l}</button>)}
        <button data-testid="logout-button" onClick={logout} className="ml-auto pb-3 text-sm text-muted-foreground hover:text-white">{t("logout")}</button>
      </div>
      {tab === "orders" && (
        <div className="divide-y divide-white/5" data-testid="account-orders">
          {!orders.length && <p className="text-muted-foreground">Aucune commande pour l'instant.</p>}
          {orders.map((o) => (
            <Link key={o.id} to={`/account/orders/${o.id}`} data-testid={`account-order-${o.number}`} className="py-5 grid grid-cols-2 md:grid-cols-4 gap-3 hover:bg-white/[0.02] transition-colors">
              <span className="font-mono text-sm">{o.number}</span><span className="text-sm text-muted-foreground">{dt(o.created_at)}</span>
              <span className="text-sm">{STATUS_FR[o.status] || o.status}</span><span className="font-mono text-sm md:text-right">{money(o.total, o.currency)}</span>
            </Link>
          ))}
        </div>
      )}
      {tab === "returns" && (
        <div className="divide-y divide-white/5" data-testid="account-returns">
          {!returns.length && <p className="text-muted-foreground">Aucune demande de retour.</p>}
          {returns.map((r) => (
            <div key={r.id} className="py-5 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm" data-testid={`account-return-${r.id}`}>
              <span className="font-mono">{r.order_number}</span><span>{r.reason}</span><span>{STATUS_FR[r.status] || r.status}</span><span className="font-mono md:text-right">{money(r.amount, r.currency)}</span>
            </div>
          ))}
        </div>
      )}
      {tab === "profile" && (
        <form onSubmit={save} className="max-w-md space-y-5">
          <Field label="Nom" testid="profile-name" value={prof.name} onChange={(e) => setProf({ ...prof, name: e.target.value })} />
          <Field label="Téléphone" testid="profile-phone" value={prof.phone} onChange={(e) => setProf({ ...prof, phone: e.target.value })} />
          <div className="flex gap-3"><button data-testid="profile-save" className={btnGold}>Enregistrer</button><Link to="/legal/consentement" className={btnGhost}>Consentements</Link></div>
        </form>
      )}
    </Page>
  );
}
